import { Box, Button, Step, StepLabel, Stepper } from "@mui/material";
import { styled } from "@mui/material/styles";
import { enumerateStages } from "logic/Navigation/NavigationHelper";
import { getStageKey, Stage } from "logic/Navigation/Stages";
import { getStage, StepId, getFirstStepOfStage } from "logic/Navigation/Steps";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
  currentStep: StepId;
  setCurrentStep: (stepId: StepId) => void;
}

const allStages: Stage[] = enumerateStages();

const Root = styled("div")(({ theme }) => ({
  width: "100%",
}));

const CustomStepLabel = styled(StepLabel)(() => ({
  "& .MuiStepLabel-label": {
    fontFamily: "var(--theme-fonts), 'Segoe UI', Arial, Helvetica, sans-serif",
  },
}));

const BookingStepperVertical: React.FC<Props> = (props: Props) => {
  const currentStage = getStage(props.currentStep);
  const { t } = useTranslation();

  if (currentStage === null) return null;

  return (
    <Root>
      <Stepper activeStep={currentStage ?? undefined} orientation="vertical">
        {allStages.map((stageId) => (
          <Step
            key={stageId}
            onClick={() => {
              if (currentStage > stageId) {
                props.setCurrentStep(getFirstStepOfStage(stageId));
              }
            }}
          >
            <CustomStepLabel>{t(getStageKey(stageId))}</CustomStepLabel>
          </Step>
        ))}
      </Stepper>
    </Root>
  );
};

export default BookingStepperVertical;
